import React from 'react'
import { createGlobalStyle } from "styled-components"
import LightTheme from '../themes/LightTheme'
import {ThemeProvider} from 'styled-components'
import {UTMContextProvider} from '../components/context/ContextUTM'
import Footer from './global/Footer';
import { PublicAudioContextProvider } from './context/AudioPlayerContext'

const GlobalStyle = createGlobalStyle`
  * {  
    box-sizing: border-box;
  }
  html {
    background-color: #ededed;
    box-sizing: border-box;
  }
  body {
    min-height: 100vh;
    position: relative;
    width: 100%;
    margin: 0px;
    color: ${({ theme }) => theme.colors.white};
    background-color: #0D0D0D;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.fontSize.md};
    overflow-x: hidden;
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    font-style: normal;
    margin: 0;
  }
  p {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    line-height: ${({ theme }) => theme.typography.lineHeight.normal};
    margin: 0;
  }
  a {
    color: ${({ theme }) => theme.colors.red};
    ;
  }
  li {
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }
  #gatsby-focus-wrapper:focus {
    outline: none;
    caret-color: transparent;
  }
`


const Layout = ({ children, location }) => {



  return (
    <>
    <PublicAudioContextProvider>
      <ThemeProvider theme={LightTheme}>
        {/* <ScrollMenu/> */}
        <UTMContextProvider location={location}>
          <GlobalStyle/>
          <div>{children}</div>
          <Footer/>
        </UTMContextProvider>
      </ThemeProvider>
    </PublicAudioContextProvider>
    </>
      
  )
}

export default Layout